import * as BusinessManagerAPI from '@wix/business-manager-api';
import {
  PageComponentId,
  appDefIds,
  isAppInstalled,
} from '@wix/business-manager-api';
import { ModuleRegistry } from 'react-module-container';
import { crmHomeMethodNames } from '../../crm-actions';

export interface Tool {
  name: string;
  navigate(referralInfo: string): void;
}

export const navigationTable = {
  inbox: PageComponentId.Engage,
  contacts: PageComponentId.Contacts,
  forms: PageComponentId.WixForms,
  automations: PageComponentId.Triggers,
  workflows: PageComponentId.Workflow,
  tasks: PageComponentId.TasksWeb,
  members: PageComponentId.MemberPermissions,
  priceQuotes: PageComponentId.PriceQuotes,
  invoices: PageComponentId.Invoices,
};

export const navigateTo = (tool: string, contextData: any) => {
  const pageComponentId = (navigationTable as any)[tool];

  BusinessManagerAPI.navigateTo({
    pageComponentId,
    contextData,
  });
};

export const initTools = () => {
  const isFormsInstalled = isAppInstalled(appDefIds.wixForms);

  return {
    inbox: {
      name: 'inbox',
      navigate: (referralInfo: string) =>
        navigateTo('inbox', {
          appState: `${referralInfo}`,
        }),
    },
    contacts: {
      name: 'contacts',
      navigate: (referralInfo: string) =>
        navigateTo('contacts', {
          appState: `${referralInfo}`,
        }),
    },
    forms: {
      name: isFormsInstalled ? 'forms' : 'createForm',
      navigate: (referralInfo: string) =>
        isFormsInstalled
          ? navigateTo('forms', {
              appState: `${referralInfo}`,
            })
          : ModuleRegistry.invoke(crmHomeMethodNames.addForm),
    },
    automations: {
      name: 'automations',
      navigate: (referralInfo: string) =>
        navigateTo('automations', {
          appState: `${referralInfo}`,
        }),
    },
    workflows: {
      name: 'workflows',
      navigate: (referralInfo: string) =>
        navigateTo('workflows', {
          appState: `${referralInfo}`,
        }),
    },
    tasks: {
      name: 'tasks',
      navigate: (referralInfo: string) =>
        navigateTo('tasks', {
          appState: `${referralInfo}`,
        }),
    },
    members: {
      name: 'members',
      navigate: (referralInfo: string) =>
        navigateTo('members', {
          appState: `members/${referralInfo}`,
        }),
    },
    priceQuotes: {
      name: 'priceQuotes',
      navigate: (referralInfo: string) =>
        navigateTo('priceQuotes', {
          appState: `${referralInfo}`,
        }),
    },
    invoices: {
      name: 'invoices',
      navigate: (referralInfo: string) =>
        navigateTo('invoices', {
          appState: `${referralInfo}`,
        }),
    },
  };
};
